import React from 'react'
import PropTypes from 'prop-types'

import { useStaticQuery, graphql } from 'gatsby'
import { RateDisclaimer } from '../Utilities'

function PromoCard({ promoData }) {
  const data = useStaticQuery(graphql`
    query {
      allContentfulCardPricingStrategy(
        filter: { amountId: { ne: null }, promoCode: { ne: null } }
      ) {
        nodes {
          strategyId
          amountId
          promoCode
        }
      }
    }
  `)

  const products = {
    Loan: {
      buttonText: 'Check Your Loan Options',
      showDisclaimer: true,
      label: 'Promotional Code (Optional)'
    },
    Card: {
      buttonText: 'Apply Now',
      showDisclaimer: false,
      productType: 'credit_card',
      label: 'Promotional Code',
      promoCodeValidation: [
        ...data.allContentfulCardPricingStrategy.nodes.map(node => node.promoCode)
      ]
    }
  }

  const { buttonText, showDisclaimer, productType, label, promoCodeValidation } =
    products[promoData.type]

  const handleSubmit = e => {
    if (!promoCodeValidation) return

    const codeEntered = e.target.promo_code.value
    if (promoCodeValidation.indexOf(codeEntered) === -1) {
      e.preventDefault()
      /* eslint-disable no-alert */
      setTimeout(() => {
        alert(`Invalid promotional code: ${codeEntered}`)
      }, 500)
    }
  }

  return (
    <div className="personal-offer personal-offer--sub">
      <form action="/apply/referrals" acceptCharset="UTF-8" method="get" onSubmit={handleSubmit}>
        <section className="form">
          <div className="form__row">
            <div className="form__group">
              <input name="utf8" type="hidden" value="✓" />
              <input
                name="promo_code"
                className="form__input"
                id="personal_offer"
                type="text"
                pattern="^\S.*$"
              />

              <input name="landing_keyword" type="hidden" value={promoData.landing_keyword} />
              {productType ? <input name="product_type" type="hidden" value={productType} /> : null}
              <label className="form__label label" htmlFor="personal_offer">
                {label}
              </label>
            </div>
          </div>
          <button className="button--primary" type="submit">
            {buttonText}
          </button>
        </section>
      </form>
      {showDisclaimer ? (
        <div className="personal-offer__text-box">
          <RateDisclaimer classNameArr={['personal-offer__icon', 'personal-offer__text']} />
        </div>
      ) : null}
    </div>
  )
}

PromoCard.defaultProps = {
  promoData: null
}

PromoCard.propTypes = {
  promoData: PropTypes.object
}

export default PromoCard
